import React, { useState, useEffect } from "react";
import { Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Portfolio } from "./components/portfolio";
// import { Testimonials } from "./components/testimonials";
// import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { ErrorPage } from "./components/ErrorPage";
import JsonData from "./data/data.json";
import { useLocation } from "react-router-dom"; // Import useLocation
import SmoothScroll from "smooth-scroll";
import LoadingScreen from "./components/LoadingScreen";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const location = useLocation(); // Get the current location
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const [loading, setLoading] = useState(true); // State variable for loading

  useEffect(() => {
    // Function to hide the loading screen after the page has loaded
    const handleLoad = () => {
      setTimeout(() => {
        setLoading(false);
      }, 600); // Initial delay to ensure loading screen is visible long enough
    };
  
    // Check if the page is already loaded (for scenarios like refresh or cached content)
    if (document.readyState === 'complete') {
      handleLoad(); // If the page is already loaded, call the handleLoad function
    } else {
      // Otherwise, listen for the 'load' event to check when the page fully loads
      window.addEventListener('load', handleLoad);
    }
  
    // Fallback: hide the loading screen after a maximum timeout in case load event fails
    const fallbackTimeout = setTimeout(() => {
      setLoading(false);
    }, 100); // Adjust this timeout value based on how long you expect the page to take to load
  
    // Clean up event listeners and timeouts
    return () => {
      window.removeEventListener('load', handleLoad);
      clearTimeout(fallbackTimeout); // Clear the fallback timeout if the load event happens first
    };
  }, []);

  useEffect(() => {
    // Check if we are not on localhost or the localhost IP
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    
    if (!isLocalhost) {
      (function(c, l, a, r, i, t, y) {
        c[a] = c[a] || function() {
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/okuh7il4pm";
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "okuh7il4pm");
    }
  }, []);



const scrollToSections = (id) => {
  const section = document.getElementById(id);
  if (section) {
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;

    // Scroll to the target section smoothly
    window.scrollTo({
      top: sectionTop, 
      behavior: 'smooth',
    });
  }
};




// Create a new HomePage component
const HomePage = ({landingPageData,scrollToSections}) => {
  return (
    <>
      <Header data={landingPageData.Header} scrollToSections={scrollToSections} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Portfolio data={landingPageData.Portfolio} />
      <Contact data={landingPageData.Contact} />
    </>
  );
};


return (
  
  <div>
      <LoadingScreen loading={loading} />
      <Navigation  location={location}  scrollToSections={scrollToSections} />
      <Routes>
        <Route path="/" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/home" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/features" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/about" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/services" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/portfolio" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        <Route path="/contact" element={<HomePage landingPageData={landingPageData} scrollToSections={scrollToSections} />} />
        {/* Catch-all route for unknown paths */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
  </div>
  
);
};

export default App;

// const scrollToSections = (sectionId) => {
//   const targetElement = document.getElementById(sectionId);
//   if (targetElement) {
//       const headerHeight = document.querySelector('header').offsetHeight; // Adjust according to your header
//       const offset = -40; // Additional margin (adjust as needed)
//       const scrollToPosition = targetElement.offsetTop - headerHeight - offset;

//       window.scrollTo({
//           top: scrollToPosition,
//           behavior: 'smooth'
//       });
//   }
// };

// // Scroll to the section based on pathname
// useEffect(() => {
//   const section = location.pathname.replace("/", ""); // Get the section from the URL
//   if (section) {
//     const element = document.getElementById(section);
//     if (element) {
//       // Smoothly scroll to the section
//       element.scrollIntoView({ behavior: "smooth" });
//     }
//   }
// }, [location]);

// const scrollToSection = (id) => {
  
//   const section = document.getElementById(id);
//   if (section) {
//     section.scrollIntoView({ behavior: "smooth", block: "start" });
//   }
  
// };